import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "sonner";
import { AuthProvider, useAuth } from "@/context/AuthContext";
import Home from "@/pages/Home";
import Login from "@/pages/Login";
import Register from "@/pages/Register";
import Chat from "@/pages/Chat";
import CreateCharacter from "@/pages/CreateCharacter";
import MyChats from "@/pages/MyChats";
import VipPage from "@/pages/VipPage";
import PaymentSuccess from "@/pages/PaymentSuccess";
import PaymentCancel from "@/pages/PaymentCancel";
import AuthCallback from "@/pages/AuthCallback";
import Subscription from "@/pages/Subscription";
import OwnerDashboard from "@/pages/OwnerDashboard";
import Profile from "@/pages/Profile";
import Coins from "@/pages/Coins";

function ProtectedRoute({ children }) {
  const { user, loading } = useAuth();
  if (loading)
    return (
      <div className="min-h-screen flex items-center justify-center bg-[#090A0F] text-slate-400">
        Loading...
      </div>
    );
  if (!user) return <Navigate to="/login" replace />;
  return children;
}

function App() {
  return (
    <div className="App">
      <AuthProvider>
        <BrowserRouter>
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/login" element={<Login />} />
            <Route path="/register" element={<Register />} />
            <Route path="/chat/:sessionId" element={<ProtectedRoute><Chat /></ProtectedRoute>} />
            <Route path="/create" element={<ProtectedRoute><CreateCharacter /></ProtectedRoute>} />
            <Route path="/edit/:id" element={<ProtectedRoute><CreateCharacter /></ProtectedRoute>} />
            <Route path="/profile" element={<ProtectedRoute><Profile /></ProtectedRoute>} />
            <Route path="/coins" element={<ProtectedRoute><Coins /></ProtectedRoute>} />
            <Route path="/my-chats" element={<ProtectedRoute><MyChats /></ProtectedRoute>} />
            <Route path="/vip" element={<VipPage />} />
            <Route path="/payment/success" element={<PaymentSuccess />} />
            <Route path="/payment/cancel" element={<PaymentCancel />} />
            <Route path="/auth/callback" element={<AuthCallback />} />
            <Route path="/subscription" element={<ProtectedRoute><Subscription /></ProtectedRoute>} />
            <Route path="/owner" element={<ProtectedRoute><OwnerDashboard /></ProtectedRoute>} />
          </Routes>
        </BrowserRouter>
        <Toaster position="top-center" theme="dark" richColors />
      </AuthProvider>
    </div>
  );
}

export default App;
